import React from "react";
import MembershipIcon from "./MembershipIcon";
import useGetMemberByStudent from "../../hooks/useGetMemberByStudent";

export default function CheckMembershipStudent({ studentId, iconSize = 25 }) {
  const { data } = useGetMemberByStudent({ studentId });
  const membership = data?.data;

  if (!membership) {
    return null;
  }

  return <MembershipIcon size={iconSize} className='membership-icon' />;
}
